import { Flex, Text } from "@scaleaq/sui-react";
import { Icon } from "../Icon";
import styles from "./ErrorIndicator.module.scss";

export namespace ErrorIndicator {
    export type Props = Flex.Row.Props & {
        errorCode?: string;
    }
}

export const ErrorIndicator = (props: ErrorIndicator.Props) => {
    const { errorCode, ...restProps } = props;

    return(
        <Flex.Row {...restProps} alignment="center-left" gap="large" className={styles["error-indicator"]}>
            <Icon name="LargeDanger" color="critical" />
            <Text.Body.Medium>
                {errorCode}
            </Text.Body.Medium>
        </Flex.Row>
    );
}